import React, { useState, useEffect, useRef } from 'react'

import Grid from '@material-ui/core/Grid';
import ImputComponent from '../../../../InputComponent';
import { LanguageFactory } from '../../../../../factories';
import { useLanguage } from '../../../../../store/languageContext';
import SearchDebounceBar from '../../../../SearchDebounce';
import SearchIcon from '@material-ui/icons/Search';
import { PropertySearch } from '../../../../../factories/propertySearchs';
import { Button, Card, Table } from 'antd';
import PageContainer from '../../../../CSIComponents/PageContainer';
import moment from 'moment';
import { sortHelper } from '../../../../../helpers/misc/sortHelper'

const format = 'MM-DD-YYYY';
interface PropsType {
    changeTab: void | any,
    setCancellationDetails: void | any,
    isEditable: void | any,
    detailData: any
}


const Cancellation = (props: PropsType) => {

    const { language } = useLanguage()
    const lang = new LanguageFactory(language)
    const initialRender = useRef(true);
    const [searchs, setSearch] = useState<string[]>([]);
    const [dataSource, setDataSource] = useState<any[]>([]);
    const [total, setTotal] = useState(dataSource.length)
    const [data, setData] = useState<any[]>([]);

    //applicalbeDaysWeek
    const columns = [
        {
            title: '',
            key: 'index',
            render: (text: string, record: [], index: number) => index += 1,
            width: '40px'
        },
        {
            title: 'Policy Code',
            dataIndex: 'policycode',
            key: 'policycode',
            sorter: (a: [], b: []) => sortHelper(a, b, 'policycode'),
            showSorterTooltip: false
        },
        {
            title: 'Non-Refundable',
            dataIndex: 'nonrefundable',
            key: 'nonrefundable',
            render: (text: string) => text === 'true' ? 'Yes' : (text === 'false' ? 'No' : ''),
            sorter: (a: [], b: []) => sortHelper(a, b, 'nonrefundable'),
            showSorterTooltip: false
        },
        {
            title: 'Start Date',
            dataIndex: 'start',
            key: 'start',
            sorter: (a: [], b: []) => sortHelper(a, b, 'start'),
            showSorterTooltip: false
        },
        {
            title: 'End Date',
            dataIndex: 'end',
            key: 'end',
            sorter: (a: [], b: []) => sortHelper(a, b, 'end'),
            showSorterTooltip: false
        },
        {
            title: 'Applicable Days of the Week',
            dataIndex: 'applicalbeDaysWeek',
            key: 'applicalbeDaysWeek',
            sorter: (a: [], b: []) => sortHelper(a, b, 'applicalbeDaysWeek'),
            showSorterTooltip: false
        }
    ]

    const onChangeSearch = (term: string) => {
        setSearchTerm(term)
        onDebounce(term)
    }
    const {
        searchTerm, setSearchTerm, searchTermDebounced, onDebounce
    } = SearchDebounceBar()
    const recentlySearchs = () => {
        return searchs.forEach((search, index) => {
            return (
                <span key={index} onClick={() => recoverSearch(search)}>
                    &nbsp;{search}{searchs.length - 1 === index ? '.' : ','}
                </span>
            )
        })
    }

    const recoverSearch = (search: string) => {
        setSearchTerm(search)
        filterData(search)
        onDebounce(search)
    }

    const saveNewSearch = (term: string) => {
        const stackSearchs = new PropertySearch(searchs)
        setSearch(stackSearchs.add(term))
    }

    const afterDebounce = (term: string) => {
        if (term) {
            saveNewSearch(term)
        }
        filterData(term)
    }

    const getData = async (data: any[]) => {
        data.forEach((item: any) => {
            item.start = item.startdate ? item.startdate?.format(format) : ''
            item.end = item.enddate ? item.enddate?.format(format) : ''
        })
        setDataSource(data);
        setData(data);
    }
    useEffect(() => {
        let dataSourceList: any[] = []
        props?.detailData?.policies?.cancelpolicy?.forEach((item: any, index: number) => {
            let dataSource = item
            const valueList = [
                { title: 'Mon', value: item.monday === "true" },
                { title: 'Tue', value: item.tuesday === "true" },
                { title: 'Wed', value: item.wednesday === "true" },
                { title: 'Thu', value: item.thursday === "true" },
                { title: 'Fri', value: item.friday === "true" },
                { title: 'Sat', value: item.saturday === "true" },
                { title: 'Sun', value: item.sunday === "true" },
            ]

            const applicalbeDaysWeek: string[] = []
            valueList.forEach(item => {
                if (item.value) {
                    applicalbeDaysWeek.push(item.title)
                }
            })

            dataSource.valueList = valueList;
            //dataSource.penalty = penalty;
            dataSource.applicalbeDaysWeek = applicalbeDaysWeek.toString();
            dataSource.startdate = item.startdate ? moment(item.startdate) : null;
            dataSource.enddate = item.enddate ? moment(item.enddate) : null;
            // dataSource.dateRenge = [moment(item.startdate), moment(item.enddate)];
            dataSourceList.push(dataSource)
            dataSource.deleteTitle = dataSource.policycode;

        })
        dataSourceList.forEach((item: any, index: number) => {
            item.key = index;
            return item
        })
        getData(dataSourceList)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [])


    const filterData = async (query: string) => {
        const filterData = data.filter((item: any) => {
            const itemData: any = {}
            columns.forEach((col: any) => {
                itemData[col['dataIndex']] = item[col.dataIndex]?.toLowerCase() || '';
            })
            return JSON.stringify(Object.values(item))
                .toLocaleLowerCase()
                .indexOf(query.toLocaleLowerCase()) > -1;
        })

        setDataSource(filterData);
    }
    useEffect(() => {
        setTotal(dataSource.length)
    }, [dataSource])
    // search functionality
    useEffect(() => {
        if (initialRender.current) {
            initialRender.current = false;
        } else {
            afterDebounce(searchTermDebounced);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [searchTermDebounced])
    return (
        <PageContainer>
            <Card style={{ marginTop: -15 }}>
                <Grid container spacing={0} className="containerSpacing py-0">
                    <Grid item xs={12} className="p-0">
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ fontWeight: 'bold', fontSize: 14, color: '#333' }}>Cancellation</div>
                            <div><Button className="db-add-btn" onClick={() => { props.isEditable(); props.changeTab('ADDCancellation') }}>Add</Button></div>
                        </div>
                    </Grid>
                    <Grid item xs={4} className="pb-0 px-0 my-0">
                        <ImputComponent
                            className='SearchBar'
                            label='Search'
                            labelShrink={true}
                            value={searchTerm}
                            onChange={onChangeSearch}
                            onFocus={() => { }}
                            onBlur={() => { }}
                            placeholder={lang.translate(language, 'cancellations_search_placeholder')}
                            endAdornment={<SearchIcon style={{ color: '#9a9a9a' }} />}
                        />
                        <div className="recentlySearchs">
                            <p>{lang.translate(language, 'recently_searched')}: {recentlySearchs()}</p>
                        </div>
                    </Grid>
                    <Grid item xs={12} className="p-0">
                        <Table
                            columns={columns}
                            dataSource={
                                dataSource
                            }
                            pagination={{
                                size: "small",
                                total,
                                showSizeChanger: true,
                                showTotal: (total, range) => `Total ${total} items, Current ${range[0]}-${range[1]}`,
                                defaultPageSize: 10,
                                defaultCurrent: 1,
                                onChange: (page, pageSize) => {
                                    // console.log(page + '===' + pageSize)
                                }
                            }}
                            onRow={record => {
                                return {
                                    onClick: () => {
                                        // @ts-expect-error explanation: table error type as by defult antd is expecting an empty array
                                        record.cancelTime = record.cancelTime?moment(record.cancelTime, 'HH:mm'):null
                                        props.setCancellationDetails(record)
                                        props.changeTab('CancellationDetails')
                                    },
                                };
                            }}
                        />
                    </Grid>
                </Grid>
            </Card>
        </PageContainer>
    )
}

export default Cancellation;

